


















































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { mapState, mapGetters } from "vuex";
// @ts-ignore
import { SearchIcon } from "vue-feather-icons";
import UcFilter from "./filter.vue";
import { SET_SEARCH_QUERY } from "@/store/mutation-types";

@Component({
  components: {
    UcFilter,
    SearchIcon,
  },
  computed: {
    ...mapState("projects", ["activeFilter", "searchQuery"]),
    // map the vuex getter 'requestsServerError' to a computed property
    // making it available i.e. for use in v-for
    ...mapGetters("projects", [
      "requests",
      "requestsServerError",
      "requestsError",
      "requestsInvalid",
      "requestsPending",
      "requestsReady",
      "requestsSuccess",
      "requestsMoved",
      "requestsClientError",
      "requestsServerError",
    ]),
  },
})
export default class Filters extends Vue {
  // mapState
  searchQuery!: string;

  get localSearchQuery(): string {
    return this.searchQuery;
  }

  set localSearchQuery(value: string) {
    this.$store.commit(`projects/${SET_SEARCH_QUERY}`, value);
  }
}
